<form (keydown.enter)="$event.preventDefault()" [formGroup]="inputForm"
      class="flex flex-col full-grow-no-shrink-no-basis">
  <div class="flex flex-row justify-start items-start auto-flex">
    <mat-form-field appearance="outline" class="flex-1-0-100">
      <mat-label>Board Name</mat-label>
      <input matInput formControlName="value" required
             data-cy="Board Name"
             particleAnalytics
             analyticsCategory="add-board"
             analyticsAction="board-name">
      <mat-error *ngIf="inputFormError.value.required">
        Please type a board name.
      </mat-error>
    </mat-form-field>

  </div>
</form>
